/* src/app/components/cbm-selector/cbm-selector.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.button {
  font-family: "Lato-Regular", serif;
  font-size: 18px;
  text-decoration: none;
  display: inline-block;
  margin: 5px;
  width: 290px;
  height: 50px;
  border-radius: 26px;
  border: none;
  padding: 10px;
  color: #5F96BA;
  outline: none !important;
}
.button:disabled {
  box-shadow: none;
  background-color: #BCBCBD !important;
  color: #797A7B !important;
  border: none;
}
.button:disabled:hover {
  box-shadow: none;
}
.button-default {
  outline: none !important;
  background-color: white;
  color: #5F96BA;
  border: 1px solid #5F96BA;
}
.button-default:hover {
  color: #284D76;
  background-color: #9FC6D8;
  border-color: #9FC6D8;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-active {
  background-color: #5F96BA;
  color: #FFF;
}
.button-active:hover {
  background-color: #9FC6D8;
  color: #284D76;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-disabled {
  background-color: #BCBCBD !important;
  color: white !important;
  border: none;
}
.button-disabled:hover {
  box-shadow: none;
}
.button-gradient {
  outline: none !important;
  background-image:
    linear-gradient(
      270deg,
      #171C8F,
      #00B7BD);
  color: white;
  border: none;
}
.button-gradient:hover {
  outline: none !important;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
@media screen and (max-width: 1000px) {
  .button {
    width: 275px;
    font-size: 15px;
  }
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.input-group-title {
  color: #284D76;
  font-size: 22px;
  font-family: "Gotham-Bold", serif;
  font-weight: bold;
}
label {
  color: #9A9B9C;
  padding: 5px 0px;
  margin: 0px 20px 0px 0px;
  font-size: 18px;
  font-family: "Lato-Regular", sans-serif;
}
label:hover {
  color: #284D76;
}
.label-error {
  color: #EB0C0C !important;
}
input,
.mat-input {
  font-family: "Gotham-Book", serif;
  color: #333333;
  font-size: 18px;
}
input::placeholder {
  color: #9A9B9C;
}
input[type=text],
input[type=date],
input[type=datetime-local],
input[type=email],
.mat-input,
select {
  margin: 2px 0px;
  width: 324px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #7376BC;
}
input[type=text]:focus,
input[type=email]:focus,
input[type=date]:focus,
input[type=datetime-local]:focus,
input[type=email]:focus {
  border-radius: 10px;
  border: 1px solid #7FABC7;
  color: #333333;
  box-shadow: none;
}
input[type=radio] {
  margin: 10px;
  color: #333333;
}
.input-error {
  border: 1px solid #EB0C0C !important;
  color: #EB0C0C !important;
}
.input-complete {
  color: #333333 !important;
}
textarea {
  border-radius: 10px;
  padding: 15px;
  font-size: 16px;
  font-family: "Gotham-Book", serif;
}
textarea:hover,
textarea:focus,
textarea:active {
  border-color: #284D76;
}
.custom-input {
  border: none !important;
  outline: none;
  flex: 1;
}
.custom-input-container {
  display: flex;
  flex-direction: row;
  border: 1px solid #5F96BA;
  border-radius: 10px;
  align-items: center;
  background-color: #FFF;
  width: 100%;
}
.custom-input-container:hover {
  border: 1px solid #284D76;
}
.custom-input-container:hover .search-button {
  background-image: url(/assets/img/icons/search_meralco_blue.png);
}
.search-button {
  background-image: url(/assets/img/icons/search.png);
  background-size: cover;
  width: 14px;
  height: 14px;
  position: relative;
  cursor: pointer;
  margin: 18px;
}
.clear-search-button {
  background-image: url(/assets/img/icons/close_button.svg);
  background-size: cover;
  width: 14px;
  height: 14px;
  position: relative;
  cursor: pointer;
  margin: 18px;
}
.custom-input-prefix {
  color: #b7b7b7;
  font-size: 16px;
}
.customer-radio {
  width: 15px;
  height: 15px;
  position: relative;
  background-image: url(/assets/img/icons/radioButton_inactive.svg);
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
}
.customer-radio-selected {
  background-image: url(/assets/img/icons/radioButton_active.svg);
}
.customer-radio input[type=radio] {
  padding: 0px;
  margin: 0px;
  display: none;
}
.customer-checkbox {
  display: inline-block;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  margin: 5px;
  cursor: pointer;
  background-image: url(/assets/img/icons/checkbox_inactive.svg);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.customer-checkbox-selected {
  background-image: url(/assets/img/icons/checkbox_active.svg);
}
.customer-checkbox input[type=checkbox] {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
  display: none;
}
@media screen and (max-width: 1000px) {
  label {
    margin: 0px;
  }
  input[type=text],
  input[type=date],
  input[type=datetime-local],
  input[type=email],
  select {
    width: 275px;
  }
  .custom-input {
    overflow: hidden;
  }
  .custom-input-container {
    width: 100%;
  }
}
.checkbox-selector {
  position: relative;
  width: 285px;
  border: 1px solid #9A9B9C;
  border-radius: 10px;
  color: #9A9B9C;
  padding: 10px;
  margin: 5px;
}
.checkbox-selector i {
  position: absolute;
  right: 15px;
  top: 14px;
}
.checkbox-selector i:hover {
  color: black;
  font-weight: bold;
}
.cbm-header {
  border-bottom: 1px solid #BCBCBD;
}
.cbm-header div {
  color: #333333;
  font-weight: bold;
  padding: 10px 15px;
}
table {
  table-layout: auto;
  width: 100%;
}
th.first,
td.first {
  width: 70%;
}
thead th {
  padding: 10px 15px;
  text-align: left;
}
thead {
  border-bottom: 1px solid #BCBCBD;
  margin-bottom: 10px;
}
td {
  padding: 0px 15px;
}
tbody tr:hover {
  padding: 0px 15px;
  background-color: #EEEEEE;
}
.pcab-btn {
  width: 35px;
  height: 35px;
  position: relative;
  margin: 5px;
  padding: 5px;
  background-color: transparent;
  border: none;
}
.pcab-btn:hover .tooltiptext {
  visibility: visible;
}
.pcab-btn .tooltiptext {
  visibility: hidden;
  width: 259px;
  height: 130px;
  background-color: #FFFFFF;
  border: solid 2px #5F96BA;
  color: #333333;
  text-align: left;
  border-radius: 6px;
  position: absolute;
  z-index: 5;
  margin: 39px 0px 0px -122px;
  font-size: 14px;
  line-height: normal;
  padding: 5px;
  box-shadow: 0px 3px 6px rgba(25, 34, 141, 0.1490196078);
  font-family: "Gotham-Book", sans-serif;
}
.pcab-btn .tooltiptext::before {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  border: 9px solid transparent;
  border-top: 0;
  border-bottom: 12px solid #5F96BA;
  transform: translate(-45%, calc(100% - 30px));
}
.pcab-btn .tooltiptext::after {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  bottom: 0;
  border: 9px solid transparent;
  border-top: 0;
  border-bottom: 12px solid #FFFFFF;
  transform: translate(-45%, calc(100% - 135px));
}
.rating-btn {
  width: 35px;
  height: 35px;
  position: relative;
  margin: 5px;
  padding: 5px;
  background-color: transparent;
  border: none;
}
.rating-btn:hover .tooltiptext {
  visibility: visible;
}
.rating-btn .tooltiptext {
  visibility: hidden;
  width: 191px;
  height: 96px;
  background-color: #FFFFFF;
  border: solid 2px #5F96BA;
  color: #333333;
  text-align: left;
  border-radius: 6px;
  position: absolute;
  z-index: 10;
  margin: 39px 0px 0px -87px;
  font-size: 14px;
  line-height: normal;
  padding: 5px;
  box-shadow: 0px 3px 6px rgba(25, 34, 141, 0.1490196078);
  font-family: "Gotham-Book", sans-serif;
}
.rating-btn .tooltiptext::before {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  border: 9px solid transparent;
  border-top: 0;
  border-bottom: 12px solid #5F96BA;
  transform: translate(-45%, calc(100% - 30px));
}
.rating-btn .tooltiptext::after {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  bottom: 0;
  border: 9px solid transparent;
  border-top: 0;
  border-bottom: 12px solid #FFFFFF;
  transform: translate(-45%, calc(100% - 101px));
}
.cbm-btn {
  width: 35px;
  height: 35px;
  position: relative;
  margin: 5px;
  padding: 5px;
  border: none;
  background-color: #FFF !important;
}
.cbm-btn:hover .tooltiptext {
  visibility: visible;
}
.cbm-btn .tooltiptext {
  visibility: hidden;
  width: 259px;
  height: 250px;
  background-color: #FFFFFF;
  border: solid 2px #5F96BA;
  color: #333333;
  text-align: left;
  border-radius: 6px;
  position: absolute;
  z-index: 10;
  margin: 39px 0px 0px -122px;
  font-size: 14px;
  line-height: normal;
  padding: 5px;
  box-shadow: 0px 3px 6px rgba(25, 34, 141, 0.1490196078);
  font-family: "Gotham-Book", sans-serif;
}
.cbm-btn .tooltiptext::before {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  border: 9px solid transparent;
  border-top: 0;
  border-bottom: 12px solid #5F96BA;
  transform: translate(-45%, calc(100% - 30px));
}
.cbm-btn .tooltiptext::after {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  bottom: 0;
  border: 9px solid transparent;
  border-top: 0;
  border-bottom: 12px solid #FFFFFF;
  transform: translate(-45%, calc(100% - 135px));
}
.tooltiptext-title {
  font-weight: bold;
  color: #284D76;
}
.searchbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background-color: #EFF6FA;
  padding: 10px;
  position: relative;
}
.filter-container {
  position: absolute;
  width: 330px;
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 3px 6px 0px rgba(25, 34, 141, 0.2509803922);
  right: 0px;
  top: 70px;
  z-index: 10;
  font-family: "Gotham-Book", serif;
  font-size: 18px;
  color: #9A9B9C;
}
.filter-title {
  color: #284D76;
  font-family: "Gotham-Bold", serif;
  font-size: 22px;
}
.show-more {
  color: #5F96BA;
  text-decoration: underline;
  cursor: pointer;
}
.desktop-hidden {
  display: none;
}
@media screen and (max-width: 768px) {
  .cbm-header {
    flex-wrap: wrap;
  }
  .cbm-header div {
    flex-basis: 100%;
    margin-bottom: 10px;
    text-align: center;
  }
  .mobile-hidden {
    display: none;
  }
  .desktop-hidden {
    display: unset;
  }
}
@media screen and (max-width: 1000px) {
  .searchbar {
    display: flex;
    flex-direction: column;
  }
  .button {
    width: 100%;
  }
  .mobile-hidden {
    display: none !important;
  }
  .desktop-hidden {
    display: unset;
  }
  .filter-container {
    width: 100%;
  }
}
/*# sourceMappingURL=cbm-selector.component.css.map */
